module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [(!_vm.editMode) ? _c('i', {
    staticClass: "material-icons back-link",
    on: {
      "click": function($event) {
        _vm.changeEditMode()
      }
    }
  }, [_vm._v("edit_mode")]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('i', {
    staticClass: "material-icons back-link",
    on: {
      "click": function($event) {
        _vm.changeEditMode()
      }
    }
  }, [_vm._v("done")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "material-icons add-link",
    attrs: {
      "tag": "i",
      "to": "/lists/new"
    }
  }, [_vm._v("add")]), _vm._v(" "), _c('h1', [_vm._v("Grocery Lists")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.sortedLists), function(list, index) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('router-link', {
      attrs: {
        "tag": "span",
        "to": '/lists/' + list['.key']
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(list.title) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.editMode) ? _c('i', {
      staticClass: "material-icons pull-right",
      on: {
        "click": function($event) {
          _vm.deleteList(index)
        }
      }
    }, [_vm._v("close")]) : _vm._e()], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-061965f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListsStart.vue
// module id = 125
// module chunks = 0